import { usePrintService } from "./usePrintService";

export default usePrintService;
